import { Spin, Tabs, Tooltip } from "antd";
import "firebase/compat/firestore";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { createAdminNotification } from "../../utils/notificationService";
import {
  BiPlus,
  BiSearch,
  BiSolidFileImport
} from "react-icons/bi";
import { FaFileImage } from "react-icons/fa";
import { FiGrid, FiLayers, FiRefreshCw, FiSettings, FiUpload } from "react-icons/fi";
import { HiSparkles } from "react-icons/hi2";
import { IoCloseSharp } from "react-icons/io5";
import { Link, useHistory } from "react-router-dom";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
import { purchaseStatuses } from "../../data";
import {
  deleteDocument,
  getDocByKeyValue,
  saveData,
  stringifySpecs,
} from "../../firebase/utility";
import BackButton from "../button/BackButton";
import GeneralButton from "../button/GeneralButton";
import CustomBadge from "../CustomBadge";
import { DropDown, SelectInputDropdown } from "../dropdown/DropDown";
import FormInput from "../formInput/FormInput";
import CancelPoConfirmation from "../modals/CancelPoConfirmation";
import CreateNewItem from "../modals/CreateNewItem";
import DeleteModal from "../modals/DeleteModal";
import GetImageUrlModal from "../modals/GetImageUrlModal";
import ImportProductsModal from "../modals/ImportProductsModal";
const PurchaseOrderDetailsHeader = ({
  state,
  handleCreate,
  handleUpdate,
  poNumber,
  obj,
  shippingCheckboxes,
  loader,
  orderData,
}) => {
  const history = useHistory();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal((prev) => !prev);
  const cancelPO = () => {
    saveData("PurchaseOrders", obj?._id, {
      purchaseOrderStatus: "cancel",
    }).then((res) => {
      if (res) {
        toast.success("PO Cancelled Successfully");
        toggle();
      }
    });
  };
  return (
    <div className="d-flex justify-content-between align-items-center ">
      <CancelPoConfirmation
        modal={modal}
        toggle={toggle}
        handleDelete={cancelPO}
      />
      <div>
        <h4>Purchase Order #{poNumber}</h4>
      </div>
      <ul className="list-unstyled d-flex align-items-center">
        {!state?.new ? (
          <>
            {!shippingCheckboxes?.do_not_email ? (
              <>
                <li
                  className="mx-3 pointer "
                  onClick={() => {
                    history.push({
                      pathname: `/admin/generate-purchase-orders-details/${state?.obj?._id}`,
                      state: {
                        obj: orderData,
                        id: orderData?.id,
                        vendor: {
                          billing: [orderData?.vendor],
                          id: orderData?.vendorOrderId,
                          _id: orderData?.vendorId,
                        },
                        type: "resend",
                      },
                    });
                  }}
                >
                  Resend PO
                </li>
                <li
                  className="mx-3 pointer"
                  onClick={() => {
                    history.push({
                      pathname: `/admin/generate-purchase-orders-details/${state?.obj?._id}`,
                      state: {
                        obj: orderData,
                        id: orderData?.id,
                        vendor: {
                          billing: [orderData?.vendor],
                          id: orderData?.vendorOrderId,
                          _id: orderData?.vendorId,
                        },
                        type: "cancel",
                      },
                    });
                  }}
                >
                  Send Cancellation Email
                </li>
              </>
            ) : (
              ""
            )}
            <li className="mx-3 pointer" onClick={toggle}>
              Cancel PO
            </li>
            <li className="mx-3">
              <GeneralButton
                title={"Update PO"}
                width={"130px"}
                className={"bg-primary-color border-0 rounded-0"}
                handleClick={handleUpdate}
                loading={loader}
                disabled={loader}
              />
            </li>
          </>
        ) : (
          <li className="mx-3">
            <GeneralButton
              title={"Create PO"}
              width={"130px"}
              className={"bg-primary-color border-0 rounded-0"}
              handleClick={handleCreate}
              loading={loader}
              disabled={loader}
            />
          </li>
        )}
        <li className="mx-3">
          <IoCloseSharp
            size={30}
            onClick={() => {
              history.goBack();
            }}
            className="pointer"
          />
        </li>
      </ul>
    </div>
  );
};
const QuotesHeader = ({
  setSearchValue,
  searchValue,
  selectedData,
  setSelectedData,
  status,
  setStatus,
  user,
  data,
  loading,
  setPage,
  gettingQuotes,
  totalCount,
}) => {
  const handleStatusChange = (status) => {
    setStatus(status);
  };

  const [searchHistory, setSearchHistory] = useState(() => {
    try {
      const history = localStorage.getItem("quoteSearchHistory");
      if (!history) return [];
      const parsed = JSON.parse(history);
      const now = Date.now();
      return parsed.filter(item => item.timestamp && (now - item.timestamp < 3600000));
    } catch (e) {
      return [];
    }
  });
  const [showHistory, setShowHistory] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setSearchHistory(prev => {
        const now = Date.now();
        const filtered = prev.filter(item => item.timestamp && (now - item.timestamp < 3600000));
        if (filtered.length !== prev.length) {
          localStorage.setItem("quoteSearchHistory", JSON.stringify(filtered));
        }
        return filtered;
      });
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const clearSearch = () => {
    setSearchValue("");
    localStorage.removeItem("quoteSearch");
    setPage(1);
  };

  const saveToHistory = (term) => {
    const cleanTerm = term?.trim();
    if (!cleanTerm || cleanTerm.length < 2) return;
    setSearchHistory((prev) => {
      const currentHistory = Array.isArray(prev) ? prev : [];
      const now = Date.now();
      const newHistory = [
        { term: cleanTerm, timestamp: now },
        ...currentHistory.filter((item) => item.term !== cleanTerm)
      ].slice(0, 10);
      localStorage.setItem("quoteSearchHistory", JSON.stringify(newHistory));
      return newHistory;
    });
  };

  useEffect(() => {
    if (searchValue && searchValue.trim().length >= 3) {
      const timer = setTimeout(() => {
        saveToHistory(searchValue);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [searchValue]);

  const handleHistoryClick = (term) => {
    setSearchValue(term);
    setPage(1);
    localStorage.setItem("quoteSearch", term);
    setShowHistory(false);
    saveToHistory(term);
  };

  const clearHistory = (e) => {
    e.stopPropagation();
    setSearchHistory([]);
    localStorage.removeItem("quoteSearchHistory");
  };
  return (
    <div className="">
      {/* Combined Header & Search Section */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        {/* Left: Title & Tabs */}
        <div className="d-flex align-items-center gap-3">
          <div className="bg-primary-soft p-2 rounded-circle shadow-sm d-none d-lg-block">
            <FiGrid size={20} className="text-primary" />
          </div>
          <div>
            <div className="d-flex align-items-center gap-3">
              <h4
                className={`fw-bold mb-0 pointer transition-all ${status === "publish" ? "text-primary border-bottom border-2 border-primary" : "text-muted opacity-75 hover-opacity-100"}`}
                onClick={() => handleStatusChange("publish")}
                style={{ fontSize: '24px' }}
              >
                Quotes
              </h4>
              <h4
                className={`fw-bold mb-0 pointer transition-all ${status === "draft" ? "text-primary border-bottom border-2 border-primary" : "text-muted opacity-75 hover-opacity-100"}`}
                onClick={() => handleStatusChange("draft")}
                style={{ fontSize: '24px' }}
              >
                Drafts
              </h4>
            </div>
            <p className="text-muted small mb-0 mt-2">({totalCount ?? 0} Total)</p>
          </div>
        </div>

        {/* Center: Search Bar */}
        <div className="flex-1 d-flex justify-content-center px-4">
          <div className="position-relative">
            <FormInput
              type={"text"}
              placeholder={"Search by ID, Customer or Name..."}
              size={"large"}
              className="border-1 shadow-none"
              icon={<BiSearch size={"20"} className="text-muted" />}
              handleChange={(e) => {
                setSearchValue(e.target.value);
                setPage(1);
                localStorage.setItem("quoteSearch", e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  saveToHistory(searchValue);
                  setShowHistory(false);
                }
              }}
              onFocus={() => setShowHistory(true)}
              onBlur={() => setTimeout(() => setShowHistory(false), 200)}
              value={searchValue}
              suffix={
                searchValue ? (
                  <IoCloseSharp
                    size={18}
                    className="text-muted pointer"
                    onClick={clearSearch}
                  />
                ) : null
              }
            />
            {showHistory && searchHistory.length > 0 && (
              <div
                className="position-absolute w-100 bg-white border shadow-lg mt-1"
                style={{
                  zIndex: 2000,
                  borderRadius: '4px',
                  maxHeight: '300px',
                  overflowY: 'auto',
                  top: '100%',
                  left: 0
                }}
              >
                <div className="d-flex justify-content-between align-items-center p-2 border-bottom bg-light sticky-top">
                  <span className="text-muted small fw-bold">RECENT SEARCHES</span>
                  <span
                    className="text-primary small cursor-pointer fw-bold"
                    onClick={clearHistory}
                    style={{ cursor: 'pointer' }}
                  >
                    Clear All
                  </span>
                </div>
                {searchHistory.map((item, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center p-2 border-bottom"
                    style={{ cursor: 'pointer', transition: 'background 0.2s' }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    onClick={() => handleHistoryClick(item.term)}
                  >
                    <BiSearch size={16} className="text-muted me-2" />
                    <span className="flex-grow-1" style={{ fontSize: '14px', color: '#333' }}>{item.term}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Right: Actions & Buttons */}
        <div className="d-flex align-items-center gap-2">
          {(user?.role === "Admin" || user?.role === "Super-admin") && selectedData?.length > 0 && (
            <GlobalHeader
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              collection={"Quotes"}
              term={"Quote"}
              items={["Delete", "DND"]}
              callftn={gettingQuotes}
            />
          )}
          <Link to={"/admin/manual-quote"} className="text-decoration-none">
            <GeneralButton
              title={"Manual Quote"}
              className={"red-button text-white shadow-sm px-3"}
              style={{ fontSize: '13px', width: 'auto' }}
              icon={<BiPlus className="me-1" />}
            />
          </Link>
          <Link to={"/admin/new-quote"} className="text-decoration-none">
            <GeneralButton
              title={"New Quote"}
              className={"create-user-btn text-white shadow-sm px-3"}
              style={{ fontSize: '13px' }}
              icon={<BiPlus className="me-1" />}
            />
          </Link>
        </div>
      </div>
    </div>

  );
};
const ProductsHeader = React.memo(({
  searchValue,
  setSearchValue,
  status,
  setStatus,
  selectedData,
  setSelectedData,
  createItemModal,
  setCreateItemModal,
  toggleCreateModal,
  selectedProduct,
  setSelectedProduct,
  user,
  data,
  page,
  setPage,
  totalPages,
  pageSize,
  loading,
  gettingProducts,
  toggleMergeModal,
  toggleImportModal,
  setImageUrlModal,
  imageUrlModal,
  importProductsModal,
  setImportProductsModal,
  toggleUploadExcelModal,
  toggleImportMadePCModal,
  toggleBulkHumanizeModal,
}) => {
  const [actionsDropdownOpen, setActionsDropdownOpen] = useState(false);
  const [newItem, setNewItem] = useState({
    vendor_part: "",
    item_mfg_part: "",
    item_upc: "",
    mfg_name: "",
    productType: "",
    mfg_com_group: "",
    mfg_condition: "",
    item_title: "",
    description: "",
    long_description: "",
    item_specification: "",
    stc_quantity: 0,
    stc_markup: "",
    stc_map: "",
    stc_cost: 0,
    stc_price: 0,
    stc_MSRP: "",
    height: 0,
    length: 0,
    width: 0,
    weight: 0,
    data_created: new Date(),
    imageUrl: "",
    sku: "TMU-",
    facebook_ignore: "",
    reset_qty: "",
    display: "",
    feed: "",
    hotselling: false,
    homePageHotSelling: false,
    quickbooks_id: "",
    category: null,
    subCategory: null,
    identifiers: [],
    updatePriceFromDnh: true,
    visible: true,
    showPriceToGuests: false,
    hidePriceFromGuests: false,
  });

  const [sku, setSku] = useState("");
  const [canSearchSku, setCanSearchSku] = useState(false);

  const [searchHistory, setSearchHistory] = useState(() => {
    try {
      const history = localStorage.getItem("productSearchHistory");
      if (!history) return [];
      const parsed = JSON.parse(history);
      const now = Date.now();
      return parsed.filter(item => item.timestamp && (now - item.timestamp < 3600000));
    } catch (e) {
      return [];
    }
  });
  const [showHistory, setShowHistory] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setSearchHistory(prev => {
        const now = Date.now();
        const filtered = prev.filter(item => item.timestamp && (now - item.timestamp < 3600000));
        if (filtered.length !== prev.length) {
          localStorage.setItem("productSearchHistory", JSON.stringify(filtered));
        }
        return filtered;
      });
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const saveToHistory = (term) => {
    const cleanTerm = term?.trim();
    if (!cleanTerm || cleanTerm.length < 2) return;
    setSearchHistory((prev) => {
      const currentHistory = Array.isArray(prev) ? prev : [];
      const now = Date.now();
      const newHistory = [
        { term: cleanTerm, timestamp: now },
        ...currentHistory.filter((item) => item.term !== cleanTerm)
      ].slice(0, 10);
      localStorage.setItem("productSearchHistory", JSON.stringify(newHistory));
      return newHistory;
    });
  };

  useEffect(() => {
    if (searchValue && searchValue.trim().length >= 3) {
      const timer = setTimeout(() => {
        saveToHistory(searchValue);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [searchValue]);

  const handleHistoryClick = (term) => {
    setSearchValue(term);
    setPage(1);
    localStorage.setItem("productSearch", term);
    setShowHistory(false);
    saveToHistory(term);
  };

  const clearHistory = (e) => {
    e.stopPropagation();
    setSearchHistory([]);
    localStorage.removeItem("productSearchHistory");
  };

  const handleStatusChange = (status) => {
    setStatus(status);
  };

  const clearSearch = () => {
    setSearchValue("");
    localStorage.removeItem("productSearch");
    setPage(1);
  };

  useEffect(() => {
    setNewItem((prev) => ({
      ...prev,
      vendor_part: selectedProduct?.vendor_part ?? "",
      item_mfg_part: selectedProduct?.item_mfg_part ?? "",
      item_upc: selectedProduct?.item_upc ?? "",
      mfg_name: selectedProduct?.mfg_name ?? "",
      productType: selectedProduct?.productType ?? "",
      mfg_com_group: selectedProduct?.mfg_com_group ?? "",
      mfg_condition: selectedProduct?.mfg_condition ?? "",
      item_title: selectedProduct?.name ?? "",
      description: selectedProduct?.description ?? "",
      long_description: selectedProduct?.long_description ?? "",
      item_specification:
        selectedProduct?.item_specification &&
          typeof selectedProduct.item_specification === "object"
          ? stringifySpecs(selectedProduct.item_specification)
          : (selectedProduct?.item_specification ?? ""),
      stc_quantity: selectedProduct?.stc_quantity ?? "",
      stc_markup: selectedProduct?.stc_markup ?? "",
      stc_map: selectedProduct?.stc_map ?? "",
      stc_cost: selectedProduct?.stc_cost ?? "",
      price: selectedProduct?.price ?? "",
      stc_MSRP: selectedProduct?.stc_MSRP ?? "",
      height: selectedProduct?.dimensions?.height ?? "",
      length: selectedProduct?.dimensions?.length ?? "",
      width: selectedProduct?.dimensions?.width ?? "",
      weight: selectedProduct?.weight ?? 0,
      data_created: new Date(),
      imageUrl: selectedProduct?.imageUrl ?? "",
      sku: selectedProduct?.sku ?? "TMU-",
      facebook_ignore: selectedProduct?.facebook_ignore ?? "",
      reset_qty: selectedProduct?.reset_qty ?? "",
      display: selectedProduct?.display ?? "",
      feed: selectedProduct?.feed ?? "",
      hotselling: selectedProduct?.hotselling ?? false,
      homePageHotSelling: selectedProduct?.homePageHotSelling ?? false,
      id: selectedProduct?.id ?? "",
      quickbooks_id: selectedProduct?.quickbooks_id ?? "",
      category: selectedProduct?.category ?? {},
      subCategory: selectedProduct?.subCategory ?? {},
      updatePriceFromDnh: selectedProduct?.updatePriceFromDnh ?? true,
      visible: selectedProduct?.visible ?? true,
      showPriceToGuests: selectedProduct?.showPriceToGuests ?? false,
      hidePriceFromGuests: selectedProduct?.hidePriceFromGuests ?? false,
    }));
  }, [selectedProduct]);

  const handleAddStock = async (sku) => {
    if (sku?.length > 0) {
      getDocByKeyValue("Products", "sku", `TMU-${sku}`).then((res) => {
        if (res?.length > 0) {
          saveData("Products", res[0]?._id, {
            stc_quantity: parseInt(res[0]?.stc_quantity) + 1,
          }).then((res) => {
            if (res) {
              toast.success("Item added in stock successfully");
              setCanSearchSku(false);
              setSku("");
            }
          });
        } else {
          toast.error("Item not found");
        }
      });
    }
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (canSearchSku) {
        handleAddStock(sku);
        setSku("");
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [sku, canSearchSku]);

  return (
    <>
      {createItemModal && (
        <CreateNewItem
          modal={createItemModal}
          toggle={toggleCreateModal}
          newItem={newItem}
          setNewItem={setNewItem}
          productSlug={selectedProduct?.slug}
          gettingProducts={gettingProducts}
          selectedProductProp={selectedProduct}
        />
      )}
      {imageUrlModal && (
        <GetImageUrlModal
          modal={imageUrlModal}
          toggle={() => setImageUrlModal(!imageUrlModal)}
        />
      )}
      {importProductsModal && (
        <ImportProductsModal
          modal={importProductsModal}
          toggle={() => setImportProductsModal(!importProductsModal)}
          gettingProducts={gettingProducts}
        />
      )}
      {/* Modern Header Section */}
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-3">

          <div>
            <h4 className="fw-bold text-dark mb-0">Products</h4>
            <div className="d-flex align-items-center gap-3 mt-2 flex-wrap">
              <div
                className="d-inline-flex p-1 rounded-3 bg-light border"
                style={{ backgroundColor: "#f8fafc", borderColor: "#e2e8f0" }}
              >
                {[
                  { key: "publish", label: "Published" },
                  { key: "inStock", label: "In Stock" },
                  { key: "incomplete", label: "Incomplete" },
                  { key: "completed", label: "Completed" },
                ].map((tab) => {
                  const isActive = status === tab.key;
                  return (
                    <button
                      key={tab.key}
                      type="button"
                      onClick={() => handleStatusChange(tab.key)}
                      className={`btn btn-sm px-3 py-1 fw-bold rounded-2 transition-all ${
                        isActive
                          ? "bg-white text-primary shadow-sm"
                          : "text-muted border-0 bg-transparent"
                      }`}
                      style={{
                        fontSize: "13px",
                        lineHeight: "1.4",
                        border: isActive ? "1px solid #e2e8f0" : "none",
                        color: isActive ? "#0d6efd" : "#64748b"
                      }}
                    >
                      {tab.label}
                    </button>
                  );
                })}
              </div>
              <span
                className="text-muted small fw-semibold d-inline-block"
                style={{ fontSize: "13px" }}
              >
                ({Number(totalPages || 0).toLocaleString()} Total)
              </span>
            </div>
          </div>
        </div>

        <div className="d-flex gap-3 align-items-center">
          <Tooltip title="Reload Products">
            <span>
              <GeneralButton
                title={"Reload"}
                className={"bg-white text-dark shadow-sm px-3 mb-0 border"}
                icon={<FiRefreshCw size={18} className="me-2 text-primary" />}
                handleClick={() => {
                  if (gettingProducts) {
                    gettingProducts(() => {
                      toast.success("Products reloaded successfully.");
                    });
                  }
                }}
              />
            </span>
          </Tooltip>
          <Tooltip title="Create a new product manually">
            <span>
              <GeneralButton
                title={"Create New Item"}
                className={"create-user-btn text-white shadow-sm px-4 mb-0"}
                icon={<BiPlus size={20} className="me-2" />}
                handleClick={() => {
                  setNewItem({
                    vendor_part: "",
                    item_mfg_part: "",
                    item_upc: "",
                    mfg_name: "",
                    productType: "",
                    mfg_com_group: "",
                    mfg_condition: "",
                    item_title: "",
                    description: "",
                    long_description: "",
                    item_specification: "",
                    stc_quantity: "",
                    stc_markup: "",
                    stc_map: "",
                    stc_cost: "",
                    price: "",
                    stc_MSRP: "",
                    height: 0,
                    length: 0,
                    width: 0,
                    weight: 0,
                    data_created: new Date(),
                    imageUrl: "",
                    sku: "TMU-",
                    facebook_ignore: "",
                    reset_qty: "",
                    display: "",
                    feed: "",
                    hotselling: false,
                    homePageHotSelling: false,
                    quickbooks_id: "",
                    category: null,
                    subCategory: null,
                    identifiers: [],
                    updatePriceFromDnh: true,
                    visible: true,
                  });
                  setSelectedProduct(null);
                  toggleCreateModal();
                }}
              />
            </span>
          </Tooltip>

          <Tooltip title="Product actions and bulk imports">
            <div className="d-flex align-items-center gap-2">
              {selectedData?.length > 0 && (
                <Tooltip title={`Bulk Humanize ${selectedData.length} selected product(s)`}>
                  <Button
                    className="d-flex align-items-center gap-2 px-3 py-2 bg-white text-primary border-primary shadow-sm rounded-8"
                    style={{ height: "40px", fontWeight: 600 }}
                    onClick={() => toggleBulkHumanizeModal && toggleBulkHumanizeModal()}
                  >
                    <HiSparkles size={16} className="text-warning" />
                    <span>Bulk Humanize ({selectedData.length})</span>
                  </Button>
                </Tooltip>
              )}
              <Dropdown
                isOpen={actionsDropdownOpen}
                toggle={() => setActionsDropdownOpen(!actionsDropdownOpen)}
              >
                <DropdownToggle
                  className="bg-white border-1 text-dark shadow-sm px-4 d-flex align-items-center gap-2 rounded-8"
                  caret
                >
                  <FiSettings size={18} className="text-primary" /> Actions
                </DropdownToggle>
                <DropdownMenu end className="shadow-lg border-0 rounded-8 p-2">
                  <DropdownItem onClick={() => toggleBulkHumanizeModal && toggleBulkHumanizeModal()} className="rounded-8 py-2">
                    <HiSparkles size={16} className="me-2 text-warning" /> Bulk AI Humanize
                  </DropdownItem>
                  <DropdownItem onClick={() => setImageUrlModal(true)} className="rounded-8 py-2">
                    <FaFileImage size={16} className="me-2 text-muted" /> Get Image URL
                  </DropdownItem>
                  <DropdownItem onClick={() => toggleImportModal()} className="rounded-8 py-2">
                    <BiSolidFileImport size={16} className="me-2 text-muted" /> Import D&H Products
                  </DropdownItem>
                  <DropdownItem onClick={() => toggleImportMadePCModal && toggleImportMadePCModal()} className="rounded-8 py-2">
                    <BiSolidFileImport size={16} className="me-2 text-muted" /> Import Made PC Products
                  </DropdownItem>
                  <DropdownItem onClick={() => toggleMergeModal()} className="rounded-8 py-2">
                    <FiLayers size={16} className="me-2 text-muted" /> Merge Products
                  </DropdownItem>
                  <DropdownItem onClick={() => setImportProductsModal(true)} className="rounded-8 py-2">
                    <FiUpload size={16} className="me-2 text-muted" /> Import Manufacturer
                  </DropdownItem>
                  <DropdownItem onClick={() => toggleUploadExcelModal()} className="rounded-8 py-2">
                    <BiSolidFileImport size={16} className="me-2 text-muted" /> Bulk Update Products
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
          </Tooltip>
        </div>
      </div>

      {/* Modern Search Section */}
      <div className="search-input-wrapper d-flex justify-content-between align-items-center mb-1">
        <div className="d-flex align-items-center gap-3 flex-1">
          <div className="position-relative" style={{ width: "350px" }}>
            <FormInput
              type={"text"}
              placeholder={"Search products by ID, Title or SKU..."}
              size={"large"}
              className="border-0 shadow-none"
              icon={<BiSearch size={"20"} className="text-muted" />}
              handleChange={(e) => {
                setSearchValue(e.target.value);
                setPage(1);
                localStorage.setItem("productSearch", e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  saveToHistory(searchValue);
                  setShowHistory(false);
                }
              }}
              onFocus={() => setShowHistory(true)}
              onBlur={() => setTimeout(() => setShowHistory(false), 200)}
              value={searchValue}
              suffix={
                searchValue ? (
                  <IoCloseSharp
                    size={18}
                    className="text-muted pointer"
                    onClick={clearSearch}
                  />
                ) : null
              }
            />
            {showHistory && searchHistory.length > 0 && (
              <div
                className="position-absolute w-100 bg-white border shadow-lg mt-1"
                style={{
                  zIndex: 2000,
                  borderRadius: '4px',
                  maxHeight: '300px',
                  overflowY: 'auto',
                  top: '100%',
                  left: 0
                }}
              >
                <div className="d-flex justify-content-between align-items-center p-2 border-bottom bg-light sticky-top">
                  <span className="text-muted small fw-bold">RECENT SEARCHES</span>
                  <span
                    className="text-primary small cursor-pointer fw-bold"
                    onClick={clearHistory}
                    style={{ cursor: 'pointer' }}
                  >
                    Clear All
                  </span>
                </div>
                {searchHistory.map((item, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center p-2 border-bottom"
                    style={{ cursor: 'pointer', transition: 'background 0.2s' }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    onClick={() => handleHistoryClick(item.term)}
                  >
                    <BiSearch size={16} className="text-muted me-2" />
                    <span className="flex-grow-1" style={{ fontSize: '14px', color: '#333' }}>{item.term}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div style={{ width: "250px" }}>
            <FormInput
              type={"text"}
              placeholder={"SKU to add in stock"}
              className="border-0 shadow-none border-start rounded-0"
              size={"large"}
              icon={<BiPlus size={"20"} className="text-primary" />}
              handleChange={(e) => {
                setCanSearchSku(true);
                setSku(e.target.value);
              }}
              value={sku}
            />
          </div>
        </div>

        <div className="d-flex align-items-center gap-2">
          {(user?.role === "Admin" || user?.role === "Super-admin") && selectedData?.length > 0 && (
            <GlobalHeader
              selectedData={selectedData}
              setSelectedData={setSelectedData}
              collection={"Products"}
              term={"Product"}
              items={["Delete"]}
              callftn={gettingProducts}
            />
          )}
        </div>
      </div>
    </>
  );
});
const PurchaseHeader = ({
  searchValue,
  setSearchValue,
  setSelectedItem,
  setSelectedData,
  selectedData,
  user,
  selectedItem,
  toggle,
  data,
  loading,
  setPage,
  gettingPos,
  totalPages,
}) => {
  const [searchHistory, setSearchHistory] = useState(() => {
    try {
      const history = localStorage.getItem("purchaseOrderSearchHistory");
      if (!history) return [];
      const parsed = JSON.parse(history);
      const now = Date.now();
      return parsed.filter(item => item.timestamp && (now - item.timestamp < 3600000));
    } catch (e) {
      return [];
    }
  });
  const [showHistory, setShowHistory] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setSearchHistory(prev => {
        const now = Date.now();
        const filtered = prev.filter(item => item.timestamp && (now - item.timestamp < 3600000));
        if (filtered.length !== prev.length) {
          localStorage.setItem("purchaseOrderSearchHistory", JSON.stringify(filtered));
        }
        return filtered;
      });
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const clearSearch = () => {
    setSearchValue("");
    localStorage.removeItem("purchaseSearch");
    setPage(1);
  };

  const saveToHistory = (term) => {
    const cleanTerm = term?.trim();
    if (!cleanTerm || cleanTerm.length < 2) return;
    setSearchHistory((prev) => {
      const currentHistory = Array.isArray(prev) ? prev : [];
      const now = Date.now();
      const newHistory = [
        { term: cleanTerm, timestamp: now },
        ...currentHistory.filter((item) => item.term !== cleanTerm)
      ].slice(0, 10);
      localStorage.setItem("purchaseOrderSearchHistory", JSON.stringify(newHistory));
      return newHistory;
    });
  };

  useEffect(() => {
    if (searchValue && searchValue.trim().length >= 3) {
      const timer = setTimeout(() => {
        saveToHistory(searchValue);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [searchValue]);

  const handleHistoryClick = (term) => {
    setSearchValue(term);
    setPage(1);
    localStorage.setItem("purchaseSearch", term);
    setShowHistory(false);
    saveToHistory(term);
  };

  const clearHistory = (e) => {
    e.stopPropagation();
    setSearchHistory([]);
    localStorage.removeItem("purchaseOrderSearchHistory");
  };
  return (
    <>
      <div className="purchase">
        <div className="d-lg-flex justify-content-between align-items-center">
          <div className="d-lg-flex justify-content-center align-items-center">
            <div className="d-flex align-items-center gap-2 position-relative">
              <FormInput
                type={"text"}
                placeholder={"Search"}
                size={"large"}
                className={`border border-1 rounded-0`}
                icon={<BiSearch size={"20"} style={{ color: "#B0B0B0" }} />}
                handleChange={(e) => {
                  setSearchValue(e.target.value);
                  setPage(1);
                  localStorage.setItem("purchaseSearch", e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    saveToHistory(searchValue);
                    setShowHistory(false);
                  }
                }}
                onFocus={() => setShowHistory(true)}
                onBlur={() => setTimeout(() => setShowHistory(false), 200)}
                value={searchValue}
                suffix={
                  searchValue ? (
                    <IoCloseSharp
                      size={18}
                      className="text-muted pointer"
                      onClick={clearSearch}
                    />
                  ) : null
                }
              />
              {showHistory && searchHistory.length > 0 && (
                <div
                  className="position-absolute w-100 bg-white border shadow-lg mt-1"
                  style={{
                    zIndex: 2000,
                    borderRadius: '4px',
                    maxHeight: '300px',
                    overflowY: 'auto',
                    top: '100%',
                    left: 0
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center p-2 border-bottom bg-light sticky-top">
                    <span className="text-muted small fw-bold">RECENT SEARCHES</span>
                    <span
                      className="text-primary small cursor-pointer fw-bold"
                      onClick={clearHistory}
                      style={{ cursor: 'pointer' }}
                    >
                      Clear All
                    </span>
                  </div>
                  {searchHistory.map((item, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center p-2 border-bottom"
                      style={{ cursor: 'pointer', transition: 'background 0.2s' }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                      onClick={() => handleHistoryClick(item.term)}
                    >
                      <BiSearch size={16} className="text-muted me-2" />
                      <span className="flex-grow-1" style={{ fontSize: '14px', color: '#333' }}>{item.term}</span>
                    </div>
                  ))}
                </div>
              )}
              <div className="mb-2">
              </div>
            </div>
            <div>
              {(user?.role === "Admin" || user?.role === "Super-admin") && selectedData?.length > 0 && (
                <GlobalHeader
                  selectedData={selectedData}
                  setSelectedData={setSelectedData}
                  collection={"PurchaseOrders"}
                  term={"Purchase Order"}
                  items={["Delete"]}
                  callftn={gettingPos}
                />
              )}
            </div>
            <div className="mx-2">
              <GeneralButton
                title={"Create Manual PO"}
                className={
                  "bg-primary-color text-white border-0 mb-3 rounded-0"
                }
                width={"180px"}
                handleClick={toggle}
              />
            </div>
            <CustomBadge title={"Purchase Orders"} length={totalPages} />
          </div>
          <div className="mx-2 shadow-sm rounded-0 mb-3 lg:mb-0">
            <SelectInputDropdown
              type={"select"}
              options={purchaseStatuses}
              className={"saleOrderDropdown"}
              value={selectedItem}
              handleChange={(e) => {
                setSelectedItem(e.target.value);
                localStorage.setItem("selectedStatus", e.target.value);
                localStorage.setItem("purchaseOrderPage", 1);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
const CustomerAndVendorHeader = ({ ID, name, handleUpdate, loader }) => {
  const history = useHistory();
  return (
    <>
      <div className="d-lg-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <h5 className="fw-bold header__title  pointer ">
            {name} Details # {ID}
          </h5>
        </div>
        <div className="d-flex align-items-center gap-3">
          <div>
            <GeneralButton
              title={"Update"}
              handleClick={handleUpdate}
              className={"bg-primary-color text-white border-0 rounded-0"}
              loading={loader}
            />
          </div>
          <div>
            <BackButton handleClick={() => history.goBack()} />
          </div>
        </div>
      </div>
    </>
  );
};
const GlobalHeader = ({
  selectedData,
  setSelectedData,
  collection,
  term,
  items,
  callftn,
}) => {
  const history = useHistory();
  const [selectedValue, setSelectedValue] = useState("Action");
  const [deleteModal, setDeleteModal] = useState(false);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  //DROPDOWN
  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const handleSelect = (i) => {
    setSelectedValue(i);
  };
  const handleDelete = () => {
    const arr = [...selectedData];
    arr.forEach((item) => {
      deleteDocument(collection, item?._id, "_id").then((res) => {
        toast.success(`${term} ${item?.id} has been deleted Successfully`);
        callftn();
        setSelectedData([]);
      });
    });
    setSelectedValue("Action");
  };
  const applyStatus = () => {
    const arr = [...selectedData];
    if (arr?.length > 0 && selectedValue === "Action") {
      toast.error("Please select any action before applying!");
    } else if (arr?.length > 0 && selectedValue !== "Action") {
      if (selectedValue === "Delete") {
        toggleDeleteModal();
      } else if (selectedValue === "Resend") {
        toast.success("Hello Resend");
      } else if (selectedValue === "DND") {
        toast.success("Hello DND");
      } else if (selectedValue === "Edit") {
        arr.forEach((item) =>
          history.push({
            pathname: `/admin/sale-order-details/${item?.id}`,
            state: item,
          }),
        );
      } else {
        Promise.all(
          arr.map((item) =>
            saveData(collection, item?._id, { status: selectedValue })
          )
        )
          .then(() => {
            const count = arr.length;
            toast.success(
              count > 1
                ? `${count} ${term}s updated to "${selectedValue}"`
                : `${term} updated to "${selectedValue}"`
            );
            createAdminNotification({
              title: `${term} Status Updated`,
              message: `${count > 1 ? `${count} ${term}s were` : `${term} was`} updated to "${selectedValue}"`,
              category:
                collection === "Orders"
                  ? "order"
                  : collection === "PurchaseOrders"
                  ? "purchase_order"
                  : "system",
              entityId: arr
                .map((i) => i.number || i.id || i.po_no)
                .filter(Boolean)
                .slice(0, 3)
                .join(", "),
              targetUrl:
                collection === "Orders"
                  ? "/admin/sale-orders"
                  : "/admin/purchase-orders",
            }).catch(console.error);
            setSelectedValue("Action");
            setSelectedData([]);
          })
          .catch((err) => {
            toast.error(err?.message || `Failed to update ${term}`);
          });
      }
    } else {
      toast.error(`Please select any ${term}!`);
    }
  };
  return (
    <>
      <DeleteModal
        toggle={toggleDeleteModal}
        modal={deleteModal}
        handleDelete={handleDelete}
      />
      <div className="purchase">
        <div className="d-lg-flex justify-content-between align-items-center ">
          <div className="d-lg-flex ">
            <div className="mx-2">
              <DropDown
                className={
                  "bg-secondary-color text-black border border-1  mb-3 rounded-0"
                }
                dropdownOpen={dropdownOpen}
                toggle={toggle}
                defaultTitle={selectedValue}
                onItemClick={handleSelect}
                items={items}
              />
            </div>
            <div className="mx-2">
              <GeneralButton
                title={"Apply"}
                className={
                  "border border-1 bg-secondary-color text-black  mb-3 rounded-0"
                }
                width={"110px"}
                handleClick={applyStatus}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export {
  CustomerAndVendorHeader,
  GlobalHeader,
  ProductsHeader,
  PurchaseHeader,
  PurchaseOrderDetailsHeader,
  QuotesHeader
};

